import 'angular:locale/data:en-GB';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "en-GB";
